import { Icon, IconName } from 'components/Icon';
import { sendAllMessageStrings } from '../../constants';
import { useCallback } from 'react';
import { formatAcceptedTypes } from 'utils/file';

type UploadBoxProps = {
  title: string;
  icon: IconName;
  acceptTypes: string[];
  maxSizeMb: number;
  onSelect: (file: File) => void;
};

export function UploadBox({
  title,
  icon,
  acceptTypes,
  maxSizeMb,
  onSelect,
}: UploadBoxProps) {
  const acceptAttr = acceptTypes.join(',');

  const openFilePicker = useCallback(() => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = acceptAttr;
    input.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) onSelect(file);
    };
    input.click();
  }, [acceptAttr, onSelect]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openFilePicker();
      }
    },
    [openFilePicker],
  );

  return (
    <div
      className="relative flex min-h-[200px] cursor-pointer flex-col items-center justify-center bg-[#F9FAFB] p-8 transition-colors hover:bg-neutral-50"
      onClick={openFilePicker}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className="mb-2 text-lg font-medium text-primary">{title}</div>
      <Icon icon={icon} width={48} height={48} color="#9CA3AF" />
      <div className="mt-4 text-center text-xs text-neutral-500">
        <div>
          {sendAllMessageStrings.fileFormats}:{' '}
          {formatAcceptedTypes(acceptTypes)}
        </div>
        <div>
          {sendAllMessageStrings.fileSizeUpTo.replace(
            '${size}',
            String(maxSizeMb),
          )}
        </div>
      </div>
    </div>
  );
}
